// Shared style constants for the onboarding flow.
// Extracted from repeated inline `sx` objects — every field that used one of
// these blocks rendered pixel-identically before the extraction.

export const FIELD_LABEL_SX = {
  fontSize: "16px",
  fontWeight: 500,
  color: "var(--app-text-muted)",
  mb: 1,
  fontFamily: "Figtree",
};

// Basic bordered TextField used for Gender (select), Organisation Name,
// Organisation Contact Number and Medical License Number.
export const BASIC_TEXT_FIELD_SX = {
  backgroundColor: "var(--app-surface)",
  borderRadius: "8px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    height: "48px",
    backgroundColor: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    "&.Mui-focused fieldset": {
      borderColor: "#E0E0E0 !important",
    },
    "&.Mui-focused": {
      boxShadow: "none",
    },
    "& fieldset": {
      border: "none",
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 14px",
  },
};

// Popup/menu styling shared by every Autocomplete in the flow
// (Profession, Organisation Type, Centre Type).
export const AUTOCOMPLETE_MENU_SX = {
  "& .MuiAutocomplete-popupIndicator": {
    color: "var(--app-text-muted)",
  },

  "& .MuiAutocomplete-clearIndicator": {
    color: "var(--app-text-muted)",
  },

  "& .MuiAutocomplete-paper": {
    borderRadius: "12px",
    marginTop: "6px",
    boxShadow: "var(--app-shadow)",
  },

  "& .MuiAutocomplete-listbox": {
    padding: "6px",

    "&::-webkit-scrollbar": {
      width: "6px",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#D1D5DB",
      borderRadius: "10px",
    },
  },

  "& .MuiAutocomplete-option": {
    minHeight: "42px",
    borderRadius: "8px",
    fontSize: "14px",
    fontFamily: "Figtree",

    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },

    '&[aria-selected="true"]': {
      backgroundColor: "var(--app-surface-2)",
      fontWeight: 400,
    },

    '&[aria-selected="true"].Mui-focused': {
      backgroundColor: "var(--app-border)",
    },
  },
};

// Common base for an Autocomplete's renderInput TextField. Each caller spreads
// this and adds its own input-text rule, since that part differs slightly
// between fields (kept as-is to avoid changing appearance).
export const AUTOCOMPLETE_INPUT_BASE_SX = {
  backgroundColor: "var(--app-surface)",
  borderRadius: "8px",

  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "var(--app-surface)",
    height: "48px",

    "& fieldset": {
      border: "1px solid var(--app-border) !important",
    },

    "&:hover fieldset": {
      border: "1px solid var(--app-border) !important",
    },

    "&.Mui-focused fieldset": {
      border: "1px solid var(--app-border) !important",
    },

    "&.Mui-focused": {
      boxShadow: "none !important",
      outline: "none !important",
    },
  },

  "& .MuiInputBase-input::placeholder": {
    color: "var(--app-text)",
    opacity: 1,
  },
};
